import { render } from "./card-module.svg?vue&type=template&id=da69eaa8?inline"
const script = {}
script.render = render

export default script